import React, { Component } from 'react';

import './App.css';
import 'tachyons';


import QRCode from 'qrcode-react';
var d = new Date();

var nowday = d.getDate();



export default class AdHocCollecting extends Component{
constructor(props){
  super(props);
  this.state ={
    code:'',
    expired:false
  }
}



componentDidMount(){
  var date = new Date();

  var thetime = date.getHours() +':'+ date.getMinutes();
  date = date.getDate() +'-'+ date.getMonth() +'-'+ date.getFullYear();
var code = document.location.pathname;
var codeb = code.slice(12);
this.setState({code:codeb}, function(){console.log('code set')})

code = atob(codeb);

//alert(code)
code = code.split("+");

var day = code[0].substring(0, 2);;



if(code[0] === date){

this.setState({expired:false})

}
else{


this.setState({expired:true})

}


}


  render() {
    return (
      <div className="App">
      <header className="App-header">

        <h1 className="App-title">Fetch My Kid</h1>
      </header>

{this.state.expired ? <div><h2>The link has expired</h2></div> :
  <div style={{display:'flex', justifyContent:'center'}}>
<div style={{marginTop:200, color:'white'}}>
<h2>Scan Code</h2>
<div className="br2 shadow-5" style={{margin:10, backgroundColor:'white',padding:30, width:'auto', height:'auto'}}>
<QRCode
value={this.state.code}
level={'H'}
size={320}
/>
</div>
</div>
</div>
}

      </div>

)
}






}



// WEBPACK FOOTER //
// ./src/AdHocCollecting.js